import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const BlockList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  margin: 0;
  padding: 0;
  list-style: none;
`

export const Block = styled.li`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.secondary};
`
